import {
  getReq,
  postReq,
  deleteSendReq,
  putReq,
  END_POINTS
} from '@/api'
// import * as dayjs from 'dayjs'
import * as Lodash from 'lodash'
// import * as Constants from '@/constant'
import * as Utils from '@/utils'
import * as StoreUtils from '@/utils/StoreUtils'

const SearchInfoBean = {
  compId: '',
  costColId: '',
  levelOneName: '',
  END_SEARCH_INFO_BEAN: null
}

const InfoBean = {
  levelOneId: '',
  compId: '',
  costColId: '',
  levelOneName: '',
  seq: 0,
  crtBy: '',
  crtOn: null,
  updBy: '',
  updOn: null
}

const state = {
  searchInfo: { ...SearchInfoBean },
  searchedForm: { ...SearchInfoBean },
  list: [],
  info: {
    ...InfoBean
  },
  listPagging: Utils.getDefaultListPagging(),
  // pdTypeLevelOneDDStore: {
  //   list: [],
  //   map: {}
  // },
  END_STATE: null
}

const getters = {

}

const actions = {
  ...StoreUtils.actions,
  insertPdTypeLevelOne({
    dispatch,
    commit,
    state,
    rootState
  }) {
    let data = {}
    Lodash.assign(data, state.info)
    return new Promise((resolve, reject) => {
      postReq(END_POINTS.INSERT_PD_TYPE_LEVEL_ONE, {data})
        .then(res => {
          StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
        }).catch(err => {
          reject(err)
        })
    })
  },
  updatePdTypeLevelOne({
    dispatch,
    commit,
    state,
    rootState
  }) {
    let data = {}
    Lodash.assign(data, state.info)
    return new Promise((resolve, reject) => {
      putReq(END_POINTS.UPDATE_PD_TYPE_LEVEL_ONE, {data})
        .then(res => {
          StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
        }).catch(err => {
          reject(err)
        })
    })
  },
  removePdTypeLevelOne({
    commit,
    state,
    rootState
  }, {key}) {
    return new Promise((resolve, reject) => {
      deleteSendReq(END_POINTS.REMOVE_PD_TYPE_LEVEL_ONE + `/${key.compId}/${key.levelOneId}`)
        .then(res => {
          state.info = res.data
          StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
        }).catch(err => {
          reject(err)
        })
    })
  },
  findPdTypeLevelOne({
    commit,
    state,
    rootState
  }, {key}) {
    return new Promise((resolve, reject) => {
      getReq(END_POINTS.FIND_PD_TYPE_LEVEL_ONE + `/${key.compId}/${key.levelOneId}`)
        .then(res => {
          state.info = res.data
          StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
        }).catch(err => {
          reject(err)
        })
    })
  },
  findPdTypeLevelOneList({
    commit,
    state,
    rootState
  }, { currentPage, pageSize }) {
    return new Promise((resolve, reject) => {
      postReq(END_POINTS.FIND_PD_TYPE_LEVEL_ONE_PAGE_LIST, {
        data: {
          currentPage,
          pageSize,
          queryVO: {
            compId: state.searchedForm.compId,
            costColId: state.searchedForm.costColId,
            levelOneName: state.searchedForm.levelOneName
          }
        }
      }).then(res => {
        state.list = res.data
        Utils.resetListPagging(state.listPagging, res)
        StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
      }).catch(err => {
        reject(err)
      })
    })
  },
  findPdTypeLevelOneDDList({
    commit,
    state,
    rootState
  }, { compId }) {
    return new Promise((resolve, reject) => {
      getReq(END_POINTS.FIND_PD_TYPE_LEVEL_ONE_DD_LIST + `/${compId}`)
        .then(res => {
          if (res.success) {
            const DDStore = Utils.getDDStore(res.data)
            // Utils.copyDDStore(DDStore, state.pdTypeLevelOneDDStore)
            resolve(DDStore)
          } else {
            StoreUtils.fn.handleResponse({rootState, resolve, reject, res})
          }
        }).catch(err => {
          reject(err)
        })
    })
  },
  END_ACTIONS() {}
}

const mutations = {
  ...StoreUtils.mutations,
  resetSearchInfo(state) {
    state.searchInfo = { ...SearchInfoBean }
  },
  resetInfo(state) {
    state.info = { ...InfoBean }
  },
  addListItem(state, { index }) {
    state.list.splice(index, 0, { ...InfoBean })
  },
  END_MUTATIONS() {}
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/proj/conf/pdTypeLevelOneManage.js